import React from "react";

type StepBadgeProps = {
    step: number;
};
export const StepBadge: React.FC<StepBadgeProps> = ({step}) => {
    return (
        <div
            className="mt-1 flex h-9 w-9 min-w-9 items-center justify-center rounded-full bg-[#f0f0f0] text-xl font-semibold text-[#1f1f1f]">
            {step}
        </div>
    );
};